 function utility(){
    function convertReactStyleToHtml(rectStyleObj,defaultStyle){
        var htmlStyleObj=defaultStyle || '';
        Object.keys(rectStyleObj).forEach(function(cssObj){
          htmlStyleObj=htmlStyleObj+cssObj.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()+":"+rectStyleObj[cssObj]+";";
        })
        return htmlStyleObj;
      }
    return {
        convertReactStyleToHtml:convertReactStyleToHtml
    }
 }
  const exportObj=utility();
  export  default exportObj;